function SearchController() {
	var _this = this
	var resultsUpdatedEvent = 'search_results_updated'

	_this.ajaxType = 7383

	this.init = function () {
		jQuery('body').delegate('a.solr-ajaxified', 'click', _this.handleClickOnAjaxifiedUri)
	}

	this.handleClickOnAjaxifiedUri = function () {
		var $category = $('h1').first()
		var clickedLink = jQuery(this)
		var solrContainer = jQuery('.lazylist-wrapper')
		var solrParent = clickedLink.closest('.tx-pxa-product-manager')
		solrContainer.html('')

		var loader = jQuery(
			"<div class='col-lg-12 col-md-12 col-sm-12 col-xs-12 col-xxs-12 loader-wrapper'><div class='lds-dual-ring'><div class='big'></div></div></div>"
		)
		var uri = clickedLink.uri()

		_this.scrollToTopOfElement(solrParent, 400)
		solrContainer.append(loader)
		uri.addQuery('type', _this.ajaxType)

		jQuery.get(uri.href(), function (data) {
			solrContainer.html(data)
			const filterUrl = solrContainer.data('filter-url')
			if (filterUrl) {
				document.querySelectorAll('[data-page-number]').forEach(function (el) {
					el.setAttribute('href', filterUrl + '&tx_kesearch_pi1[page]=' + el.getAttribute('data-page-number'))
				})
			}
			jQuery('body').trigger(resultsUpdatedEvent)
			loader.fadeOut().remove()

			var resultCount = $('.result-found').text().trim()

			$('.results-count').text(resultCount)
			var $resultsCountController = $category.parent().parent().find('.results-count-container').first()
			$resultsCountController.show()
		})
		return false
	}

	this.scrollToTopOfElement = function (element, deltaTop) {
		jQuery('html, body').animate(
			{
				scrollTop: element.position().top - deltaTop,
			},
			'slow'
		)
	}

	this.setAjaxType = function (ajaxType) {
		_this.ajaxType = ajaxType
	}
}

jQuery(document).ready(function () {
	var solrSearchController = new SearchController()
	solrSearchController.init()

	if (typeof solrSearchAjaxType !== 'undefined') {
		solrSearchController.setAjaxType(solrSearchAjaxType)
	}
})
